import { AccountCategory, ScheduleVendorAcctCategoryAssoc, Vendor } from "./index";

export class ScheduleTaskTradePartnerView {
    public id: number;
    public jobId: number;
    public masterTaskName: string;
    public masterTaskAccountCategory: AccountCategory;
    public scheduleVendorAcctCategoryAssoc: ScheduleVendorAcctCategoryAssoc;
    public templateVendor: Vendor;
    public sentForPayment: boolean;
}